import { sortOnPriority } from "../ArticlesHelpers";

export class Articlegroup {
  constructor(id, name, handheld_bg_color, priority, articleIds = [], translation_id, updatedAt, pos_name) {
    this.id = id;
    this.name = name;
    this.handheld_bg_color = handheld_bg_color;
    this.articleIds = articleIds;
    this.priority = priority;
    this.translation_id = translation_id;
    this.updated_at = updatedAt;
    this.pos_name = pos_name;
  }

  getArticles(articles) {
    return sortOnPriority(this.articleIds.map((articleId) => articles[articleId]));
  }

  get key() {
    return this.id + "-" + this.updated_at;
  }
}

export const CreateArticlegroup = (json, articleIds) =>
  new Articlegroup(
    json.id,
    json.name,
    json.handheld_bg_color,
    json.priority,
    articleIds,
    json.translation_id,
    json.updated_at,
    json.pos_name
  );
